import React from 'react';
import AutocompleteInput from './autocompleteInput';
import FileUpload from './fileUpload';
import HtmlInfo from './htmlInfo';
import HtmlPopup from './htmlPopup';
import MapInfo from './mapInfo';
import Media from './media';
import MultipleSelectInput from './multipleSelectInput';
import SelectInput from './selectInput';
import Subtitle from './subtitle';
import TextArea from './textArea';
import TextBox from './textBox';
import Title from './title';

const FormComponentWrapper = (props) => {
  if (props.formProperty) {
    var formProperty = props.formProperty;
    var type = formProperty.type;
    var inputType = formProperty.metadata.inputType;
    var finalType = inputType != "NA" ? inputType : type;
    var error = null;

    if (props.errors) {
      for (var i = 0; i < props.errors.length; i++) {
        if (props.errors[i].fieldKey == formProperty.key &&
          props.errors[i].messageCode != 18202) {
          error = props.language.error[`codTask${props.errors[i].messageCode}`];
        }
      }
    }

    switch (finalType) {
      case 'Title':
        return (
          <Title
            label={formProperty.label}
          />
        );
      case 'Subtitle':
        return (
          <Subtitle
            label={formProperty.label}
          />
        );
      case 'String':
      case 'Type':
      case 'Subtype':
      case 'State':
      case 'Relation':
      case 'Tag':
      case 'Integer':
      case 'Long':
      case 'Time':
      case 'Double':
      case 'DateTime':
        return (
          <TextBox
            id={"input" + formProperty.key}
            inputId={formProperty.key}
            value={props.saveData.value}
            label={formProperty.label + ":"}
            key={"input" + formProperty.key}
            readOnly={!formProperty.metadata.isEditable}
            className={formProperty.metadata.category}
            required={formProperty.metadata.required}
            handleOnChange={props.handleOnChange}
            error={error}
          />
        );
      case 'Text':
        return (
          <TextBox
            id={"input" + formProperty.key}
            inputId={formProperty.key}
            value={props.saveData.value}
            label={formProperty.label + ":"}
            key={"input" + formProperty.key}
            readOnly={!formProperty.metadata.isEditable}
            required={formProperty.metadata.required}
            handleOnChange={props.handleOnChange}
            className={formProperty.metadata.category}
            error={error}
          />
        );
      case 'Textarea':
        return (
          <TextArea
            id={"input" + formProperty.key}
            inputId={formProperty.key}
            value={props.saveData.value}
            label={formProperty.label + ":"}
            key={"input" + formProperty.key}
            readOnly={!formProperty.metadata.isEditable}
            required={formProperty.metadata.required}
            handleOnChange={props.handleOnChange}
            className={formProperty.metadata.category}
            error={error}
          />
        );
      case 'GPSPoint':
        return (
          <MapInfo
            id={"input" + formProperty.key}
            inputId={formProperty.key}
            value={props.saveData.value}
            label={formProperty.label + ":"}
            key={"input" + formProperty.key}
            readOnly={!formProperty.metadata.isEditable}
            className={formProperty.metadata.category}
          />
        );
      case 'HTMLInLine':
        return (
          <HtmlInfo
            id={"input" + formProperty.key}
            inputId={formProperty.key}
            value={props.saveData.value}
            label={formProperty.label + ":"}
            key={"input" + formProperty.key}
            readOnly={!formProperty.metadata.isEditable}
            className={formProperty.metadata.category}
          />
        );

      case 'HTMLPopUp':
        return (
          <HtmlPopup
            id={"input" + formProperty.key}
            inputId={formProperty.key}
            value={props.saveData.value}
            label={formProperty.label + ":"}
            key={"input" + formProperty.key}
            readOnly={!formProperty.metadata.isEditable}
            className={formProperty.metadata.category}
            handleModalHtmlPopup={props.handleModalHtmlPopup}
          />
        );

      case 'Select':
        return (
          <SelectInput
            id={"input" + formProperty.key}
            inputId={formProperty.key}
            value={props.saveData.value}
            loading={props.saveData.loading}
            status={props.saveData.status}
            options={props.saveData.options}
            label={formProperty.label + ":"}
            key={"input" + formProperty.key}
            readOnly={!formProperty.metadata.isEditable}
            required={formProperty.metadata.required}
            handleOnChange={props.handleOnChange}
            className={formProperty.metadata.category}
            endpoint={formProperty.metadata.endpoint}
            getOptionsEndpoint={props.getOptionsEndpoint}
            error={error}
          />
        );

      case 'Autocomplete':
        return (
          <AutocompleteInput
            id={"input" + formProperty.key}
            inputId={formProperty.key}
            value={props.saveData.value}
            loading={props.saveData.loading}
            status={props.saveData.status}
            options={props.saveData.options}
            label={formProperty.label + ":"}
            key={"input" + formProperty.key}
            readOnly={!formProperty.metadata.isEditable}
            required={formProperty.metadata.required}
            handleOnChange={props.handleOnChange}
            className={formProperty.metadata.category}
            placeholder={formProperty.metadata.placeholder}
            endpoint={formProperty.metadata.endpoint}
            getOptionsEndpoint={props.getOptionsEndpoint}
            error={error}
          />
        );

      case 'Checkbox':
        return (
          <MultipleSelectInput
            id={"input" + formProperty.key}
            inputId={formProperty.key}
            value={props.saveData.value}
            loading={props.saveData.loading}
            status={props.saveData.status}
            options={props.saveData.options}
            label={formProperty.label + ":"}
            key={"input" + formProperty.key}
            readOnly={!formProperty.metadata.isEditable}
            required={formProperty.metadata.required}
            handleOnChange={props.handleOnChange}
            className={formProperty.metadata.category}
            endpoint={formProperty.metadata.endpoint}
            getOptionsEndpoint={props.getOptionsEndpoint}
            error={error}
            language={props.language}
          />
        );

      case 'File':
        return (
          <FileUpload
            id={"input" + formProperty.key}
            inputId={formProperty.key}
            value={props.saveData.value}
            label={formProperty.label + ":"}
            key={"input" + formProperty.key}
            readOnly={!formProperty.metadata.isEditable}
            required={formProperty.metadata.required}
            fileLinks={formProperty.metadata.endpoint}
            className={formProperty.metadata.category}
            handleOnChange={props.handleOnChange}
            getTaskFile={props.getTaskFile}
            error={error}
          />
        );

      case 'Media':
        return (
          <Media
            id={"input" + formProperty.key}
            inputId={formProperty.key}
            label={formProperty.label + ":"}
            key={"input" + formProperty.key}
            readOnly={!formProperty.metadata.isEditable}
            required={formProperty.metadata.required}
            endpoint={formProperty.metadata.endpoint}
            getOptionsEndpoint={props.getOptionsEndpoint}
            className={formProperty.metadata.category}
            mediaData={props.saveData.options}
            loading={props.saveData.loading}
            status={props.saveData.status}
            language={props.language}
          />
        );

      default:
        return null;
    }
  }
  else {
    return null;
  }
};

export default FormComponentWrapper;


// WEBPACK FOOTER //
// ./source/client/components/tasks_manager/form_components/formComponentWrapper.jsx